import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import Confirm from 'app/components/Confirm';
import Modal from 'components/base/Modal';
import CellWithInput from 'components/base/Table/CellWithInput';
import { getPopupRegistration, openPopup } from 'app/PopupHolder';
import ButtonImport from 'components/base/ButtonImport';
import { decorate } from 'app/Property/Detail/UrlStorage';
import Table, { Column } from 'components/base/Table';
import FormControlWraper from 'components/base/FormControlWraper';
import { PropertyAssignmentPopup } from 'app/components/GroupAssignment';

import {
  uploadContract,
  loadContracts,
  loadContract,
  deleteContract,
  saveContract,
  loadContractProperties,
  saveContractProperties,
  resetContracts,
  selectIsLoading,
  selectContractsData,
  selectIsContractsLoading,
} from 'data/contracts';

import css from './style.scss';
import classNames from 'classnames';
import SVG from 'components/base/SVG';

class ContractManager extends PureComponent {
  constructor(props) {
    super(props);

    this.handleUpload = this.handleUpload.bind(this);
    this.renderDefaultCell = this.renderDefaultCell.bind(this);
    this.renderButtonCell = this.renderButtonCell.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleAssignClick = this.handleAssignClick.bind(this);

    this.state = { searchString: '' };
  }

  componentDidMount() {
    this.props.loadContracts();
  }

  componentDidUpdate(prevProps) {
    // Reload contracts when modal reopens
    if (this.props.isOpen && !prevProps.isOpen) {
      this.props.loadContracts();
      this.setState({
        searchString: '',
      });
    }
  }

  componentWillUnmount() {
    // Clean up Redux state when component unmounts
    if (this.props.resetContracts) {
      this.props.resetContracts();
    }
  }

  handleUpload(event) {
    const files = event.target.files;
    if (files && files[0] && files[0] instanceof File) {
      const fileName = files[0].name.replace(/\.[^/.]+$/, '');
      const formData = new FormData();
      formData.append('file', files[0]);
      formData.append('name', fileName);
      formData.append('description', '');
      this.props.uploadContract(formData);
    }
    // Reset file input to allow re-uploading same file
    event.target.value = '';
  }

  handleFilterChange(event) {
    const { value } = event.target || event;
    const searchString = value;
    this.setState({ searchString });
  }

  handleDelete(id) {
    const { confirmDelete, deleteContract } = this.props;
    confirmDelete({
      question: 'Do you want to delete contract?',
      onOk: () => deleteContract(id),
    });
  }

  handleClose() {
    // Reset internal state
    this.setState({
      searchString: '',
    });
    // Close the popup
    if (this.props.closePopup) {
      this.props.closePopup();
    }
  }

  handleAssignClick(contractId) {
    const { loadContractProperties, saveContractProperties, openPropertyAssignmentPopup } =
      this.props;

    loadContractProperties(contractId, {
      afterSuccess: ({ response: ids }) =>
        openPropertyAssignmentPopup({
          ids,
          onSave: (ids) => saveContractProperties(contractId, ids),
        }),
    });
  }

  renderDefaultCell(value, indexes, data) {
    const { loading, saveContract } = this.props;

    return (
      <CellWithInput
        keyPath={indexes.fieldPath}
        id={data.get('id')}
        data={data}
        onSave={saveContract}
        isLoading={loading}
      >
        <div>{value}</div>
      </CellWithInput>
    );
  }

  renderButtonCell(value, indexes, data) {
    const { loading, saveContract, loadContract } = this.props;
    const id = data.get('id');
    const btn = { isLoading: loading };

    return (
      <CellWithInput
        keyPath={indexes.fieldPath}
        id={id}
        data={data}
        onSave={saveContract}
        isLoading={loading}
      >
        <div className={css.buttonContainer}>
          <div className={css.description}>{value}</div>
          <div className={css.hiddenCell}>
            {data.get('standard') ? null : (
              <button
                className={classNames(css.btnSecondary, css.tablebtn)}
                {...btn}
                onClick={() => this.handleDelete(id)}
              >
                Delete
              </button>
            )}
            <button
              className={classNames(css.btnSecondary, css.tablebtn)}
              {...btn}
              onClick={() => loadContract(id)}
            >
              View Contract
            </button>
            <button
              className={classNames(css.btnSecondary, css.tablebtn)}
              {...btn}
              onClick={() => this.handleAssignClick(id)}
            >
              Assign
            </button>
          </div>
        </div>
      </CellWithInput>
    );
  }

  render() {
    const { loading, contracts, isOpen } = this.props;
    const { searchString } = this.state;
    // Filter contracts by search string
    const data = contracts.filter((item) =>
      item.get('name', '').toLowerCase().includes(searchString.toLowerCase().trim())
    );

    // Ensure isOpen is a boolean
    const modalIsOpen = isOpen !== undefined ? isOpen : true;

    return (
      <Modal
        isOpen={modalIsOpen}
        uniqId="contract-manager-modal"
        padding="32px"
        caption="Manage Contracts"
        width="1050px"
        onClose={this.handleClose}
      >
        <div className={css.body}>
          <Table data={data} keyField="id" isHoverable className="type_12">
            <Column field="name" renderCell={this.renderDefaultCell}>
              <div className={css.inputContainer}>
                <span className={classNames(css.cmHeader)}>
                  Contract Name <span className={css.cmHeaderBorder} />
                </span>
                <div className={css.thRow}>
                  <FormControlWraper id="contractNameFilter">
                    <div className={css.inputWrapper}>
                      <input
                        type="text"
                        onChange={this.handleFilterChange}
                        value={searchString}
                        className={css.inputWithIcon}
                        placeholder="Search contracts..."
                      />
                      <span className={css.iconWrapper}>
                        <SVG icon="search-icon" />
                      </span>
                    </div>
                  </FormControlWraper>
                </div>
              </div>
            </Column>
            <Column field="description" renderCell={this.renderButtonCell}>
              <div className={css.inputContainer}>
                <span className={css.cmHeader}>Description</span>
                <div className={css.thRow} />
              </div>
            </Column>
          </Table>
        </div>
        <div className={css.footer}>
          <button
            className={classNames(css.btnSecondary, css.footerbtn)}
            onClick={this.handleClose}
          >
            Close
          </button>
          <ButtonImport
            className={classNames(css.btnPrimary, css.footerbtn)}
            isLoading={loading}
            onChange={this.handleUpload}
          >
            Upload
          </ButtonImport>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: selectIsLoading(state),
  contracts: selectContractsData(state),
  isLoading: selectIsContractsLoading(state),
  somethingIsLoading: selectIsLoading(state),
});

const mapDispatchToProps = {
  uploadContract,
  loadContracts,
  loadContract,
  deleteContract,
  saveContract,
  confirmDelete: Confirm.open,
  loadContractProperties,
  saveContractProperties,
  openPropertyAssignmentPopup: PropertyAssignmentPopup.open,
  resetContracts,
};

// Connect and decorate the component
const ContractManagerPopup = connect(
  mapStateToProps,
  mapDispatchToProps
)(decorate(ContractManager));

// Register the popup and expose open method
const registrationId = getPopupRegistration(ContractManagerPopup);

// Add a check to ensure registrationId is valid
if (!registrationId) {
  console.error('Failed to register ContractManagerPopup');
}

// FIX: The open method needs to be defined carefully to avoid undefined actions
ContractManagerPopup.open = (props = {}) => {
  console.log('Opening ContractManagerPopup with props:', props);

  if (!registrationId) {
    console.error('Cannot open ContractManagerPopup: No registration ID');
    return null;
  }

  // Ensure we have valid props
  const safeProps = props || {};

  // IMPORTANT: Don't pass undefined or invalid actions
  // Just pass the props directly without any action creators
  return openPopup(registrationId, {
    ...safeProps,
    // Add a unique key to force remount
    key: `contract-manager-${Date.now()}`,
    // Ensure isOpen is explicitly set
    isOpen: true,
  });
};

// Also add a close method for convenience
ContractManagerPopup.close = () => {
  if (registrationId) {
    return openPopup(registrationId, {
      isOpen: false,
      key: `contract-manager-close-${Date.now()}`,
    });
  }
};

export default ContractManagerPopup;
